import { useEffect, useState } from "react";
import { ApiUrl } from "./components/API/Api";
import Quotation from "./components/Quotation";
import About from "./components/about";
import Footer from "./components/footer";
import Header from "./components/header";
import Ourstatic from "./components/ourstatic";
import Scrollbar from "./components/scrollbar";
import Slider from "./components/slider";
import axios from "axios";
import Youtube from "./components/Youtube";
import News from "./components/News";
import { ThreeDots } from "react-loader-spinner";

function Home() {
  const [loading, setLoading] = useState(true);
  const [homedata, setHomedata] = useState(null);

  useEffect(() => {

    const fetchData = async () => {
      try {
        const response = await axios.get(`${ApiUrl}/get/homepagee/sections`);
        localStorage.setItem("HomeData", JSON.stringify(response?.data?.data));
        setHomedata(response?.data?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <ThreeDots
          visible={true}
          height="50"
          width="50"
          color="#912849"
          radius="9"
          ariaLabel="chengai-diocese-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />

      </div>
    );
  }

  return (
    <>
      <Header menuData={homedata?.headermenudata} />
      <Slider sliderdata={homedata?.SlidesData} />
      <Scrollbar projectdata={homedata?.upcomingevents} />
      <About />
      <Ourstatic />
      <News projectdata={homedata?.upcomingevents} />
      <br />
      <Quotation />
      <br />
      <Youtube newsletterdata={homedata?.newslettersdata} />
      <br />
      <Footer />
    </>
  );
}

export default Home;
